import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.process-steps' ).length ) {
        $( '.process-steps' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            drag: 'free',
            perPage: 2,
            pagination: false,
            perMove: 1,
            gap: '12px',
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );
          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                focus: 0,
              };
            }
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'process-steps', COMPONENT );
} )( app );
